// Update display product page tiles on variant change
function updateDisplayType(event, type) {
  const messageType = type === "standard" ? "standard" : "plate";
  const messageTypeElements = document.querySelectorAll(".message-type");
  const messageTypeItemElements = document.querySelectorAll(".message-type-item");
  messageTypeElements.forEach((element) => {
    element.classList.remove("standard", "plate");
    element.classList.add(messageType);
  });
  messageTypeItemElements.forEach((element) => {
    element.classList.remove("standard", "plate");
    element.classList.add(messageType);
    if (element.classList.contains("display-review-chip")) {
      element.textContent = getDisplayShortType(type);
    }
  });

  const includedPlateImages = document.querySelectorAll(".whats-included-display-plate");
  includedPlateImages.forEach((includedPlateImage) => {
    includedPlateImage.dataset.type = type;
  });
}

function getDisplayShortType(type) {
  const shortType = {
    "leave-a-review": "Review",
    "view-menu": "Menu",
    "check-in": "Check In",
    "follow-us": "Follow",
    "donate": "Donate",
    "order-now": "Order",
    "join-now": "Join",
    "download": "Download",
    "book-now": "Book",
    "connect-to-wifi": "WiFi",
    "leave-a-tip": "Tip"
  };

  return shortType[type] || type;
}